//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[1,"LineardimTransmissionAttenuationDistance",0,"Expression",0],[1,"LineardimTransmissionScatterDistance",0,"Expression",0],[0,"MaterialName",1,0],[0,"TransmissionAbbeNumber",1,0],[0,"TransmissionIOR",1,0],[0,"TransmissionSolidVolume",1,0],[0,"TransmissionSubSurfaceScatter",1,0],[0,"TransmissionTranslucency",1,0],[0,"TransmissionTransparency",1,0]],[[["filename"],"SetTransmissionTransparencyTexture",{},1,0],[[],"GetTransmissionTransparencyTexture",{R_:{filename:''}},0,0],[["filename"],"SetTransmissionTranslucencyTexture",{},1,0],[[],"GetTransmissionTranslucencyTexture",{R_:{filename:''}},0,0],[["nRGBColorPickerColor"],"GetTransmissionAttenuationColor",{R_:{rGBColorPickerColor:""}},0,0],[["rGBColorPickerColor"],"SetTransmissionAttenuationColor",{},1,0]],[]];
SPLM.Display.VisualMaterialEditorTransmissionBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.VisualMaterialEditorTransmissionBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;